import type { Category, HeaderProps } from '@/types/shared-types';

export const compressNavJson = (data: HeaderProps): HeaderProps => {
    // Bring third level links up to the second level when
    // the second level is a redudant category.
    const compressCategories = (catagories: Category[]) => {
        return catagories.map((cat: Category) => {
            if (cat.children) return cat;
            return {
                ...cat,
                items: cat.items?.[0]?.items,
            };
        });
    };

    return {
        ...data,
        menu: {
            ...data.menu,
            categories: compressCategories(data.menu.categories),
        },
    };
};
